module.exports = __webpack_public_path__ + "img/ngc.d3cab37d.svg";